import { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import DashboardLayout from 'src/layouts/dashboard';
import { LoadingScreen } from 'src/components/loading-screen';
import { useHotmixEnabled } from 'src/hooks/use-hotmix-enabled';
import { paths } from 'src/routes/paths';

// ----------------------------------------------------------------------

const GrnHotmixPage = lazy(() => import('src/sections/grn-hotmix/grn-hotmix-view'));

// Opening /grn-hotmix directly when the company does not have the feature
// sends the admin back to the Dashboard.
function HotmixGuard({ children }) {
  const { loading, enabled } = useHotmixEnabled();
  if (loading) return <LoadingScreen />;
  if (!enabled) return <Navigate to={paths.dashboard.root} replace />;
  return children;
}

// ----------------------------------------------------------------------

// Same layout pattern as the other Admin Panel pages (e.g. materials routes)
export const grnHotmixRoutes = [
  {
    path: 'grn-hotmix',
    element: (
      <DashboardLayout>
        <HotmixGuard>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </HotmixGuard>
      </DashboardLayout>
    ),
    children: [{ element: <GrnHotmixPage />, index: true }],
  },
];
